import { render, staticRenderFns } from "./single-product.vue?vue&type=template&id=7ab163e7&scoped=true&"
import script from "./single-product.vue?vue&type=script&lang=js&"
export * from "./single-product.vue?vue&type=script&lang=js&"
import style0 from "./single-product.vue?vue&type=style&index=0&id=7ab163e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab163e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VBtnToggle,VCard,VCardActions,VCardTitle,VDivider})
